export default __webpack_public_path__ + "static/media/record.4bc979db.svg";